import { Toast } from 'react-bootstrap';
import { useEffect, useState } from 'react';

interface Props {
    show: boolean,
    message: string
    heading: string
    type: 'ERROR' | 'SUCCESS' | 'INFO'
    onClose?: () => void
    autoFadeTime?: number // New property for auto fade time
}
const CustomToast = ({ show, message, heading, type, onClose, autoFadeTime = 2000 }: Props) => { // Default auto fade time to 5 seconds
    const [showLiveToast, setShowLiveToast] = useState(show);

    const handleLiveToastClose = () => {
        setShowLiveToast(false);
        if(onClose){
            onClose();
        }
    };

    useEffect(() => {
        setShowLiveToast(show);
        let timer: any;
        if (show) {
            timer = setTimeout(() => {
                setShowLiveToast(false);
                if (onClose) {
                    onClose();
                }
            }, autoFadeTime);
        }
        return () => clearTimeout(timer);
    }, [show, autoFadeTime, onClose]);

    return (
        <div className="toast-container position-fixed bottom-0 end-0 p-3">
        <Toast
            show={showLiveToast}
            onClose={handleLiveToastClose}
            id="liveToast"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            className={`colored-toast bg-${getClassName(type)}-transparent`}
        >
            <Toast.Header closeButton className={`bg-${getClassName(type)} text-fixed-white`}>
                <strong className="me-auto">{heading}</strong>
            </Toast.Header>
            <Toast.Body>{message}</Toast.Body>
        </Toast>
    </div>
    )
}

function getClassName(type: string) {
    switch (type) {
        case 'ERROR':
            return 'danger';
        case 'SUCCESS':
            return 'success';
        case 'INFO':
            return 'secondary';
        default:
            return '';
    }
}

export default CustomToast;
